



















import { Component, Prop, Vue } from 'vue-property-decorator';

import { Option } from '@/shared/models/view/option-viewmodel';

@Component({})
export default class SelectOptions extends Vue {
    @Prop() id? : string;
    @Prop() name? : string;
    @Prop() value?: any;
    @Prop() placeholder? : string;
    @Prop() options?: Option[];
    @Prop() required?: boolean;
    @Prop() selectClass?: string;
    @Prop() optionGroup?: boolean;
    @Prop() disabled?: boolean;
    
    private selected: any = this.value || "";
    
    mounted() {
        this.selected = this.value || "";
    }
    
    private sendValue() {
        this.$emit('update', this.selected)
    }
}
